import { styled } from 'react-jss'

export const Image = styled('img')(({ theme, height = "100px", isSelected }) => ({
  aspectRatio: 1 / 1,
  borderRadius: '50%',
  boxShadow: isSelected ? `0 0 5px 5px ${theme.primary}` : 'none',
  height,
  transition: 'all 0.3s',
}))
